/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateRecordingEnvelopePayloadArtistsInner } from './CreateRecordingEnvelopePayloadArtistsInner';
import {
    CreateRecordingEnvelopePayloadArtistsInnerFromJSON,
    CreateRecordingEnvelopePayloadArtistsInnerFromJSONTyped,
    CreateRecordingEnvelopePayloadArtistsInnerToJSON,
} from './CreateRecordingEnvelopePayloadArtistsInner';
import type { CreateRecordingEnvelopePayloadContributionsInner } from './CreateRecordingEnvelopePayloadContributionsInner';
import {
    CreateRecordingEnvelopePayloadContributionsInnerFromJSON,
    CreateRecordingEnvelopePayloadContributionsInnerFromJSONTyped,
    CreateRecordingEnvelopePayloadContributionsInnerToJSON,
} from './CreateRecordingEnvelopePayloadContributionsInner';
import type { CreateRecordingEnvelopePayloadRecording } from './CreateRecordingEnvelopePayloadRecording';
import {
    CreateRecordingEnvelopePayloadRecordingFromJSON,
    CreateRecordingEnvelopePayloadRecordingFromJSONTyped,
    CreateRecordingEnvelopePayloadRecordingToJSON,
} from './CreateRecordingEnvelopePayloadRecording';
import type { CreateRecordingEnvelopePayloadRelease } from './CreateRecordingEnvelopePayloadRelease';
import {
    CreateRecordingEnvelopePayloadReleaseFromJSON,
    CreateRecordingEnvelopePayloadReleaseFromJSONTyped,
    CreateRecordingEnvelopePayloadReleaseToJSON,
} from './CreateRecordingEnvelopePayloadRelease';

/**
 * 
 * @export
 * @interface CreateRecordingEnvelopePayload
 */
export interface CreateRecordingEnvelopePayload {
    /**
     * 
     * @type {CreateRecordingEnvelopePayloadRecording}
     * @memberof CreateRecordingEnvelopePayload
     */
    recording: CreateRecordingEnvelopePayloadRecording;
    /**
     * 
     * @type {Array<CreateRecordingEnvelopePayloadArtistsInner>}
     * @memberof CreateRecordingEnvelopePayload
     */
    artists?: Array<CreateRecordingEnvelopePayloadArtistsInner>;
    /**
     * 
     * @type {Array<CreateRecordingEnvelopePayloadContributionsInner>}
     * @memberof CreateRecordingEnvelopePayload
     */
    contributions?: Array<CreateRecordingEnvelopePayloadContributionsInner>;
    /**
     * 
     * @type {CreateRecordingEnvelopePayloadRelease}
     * @memberof CreateRecordingEnvelopePayload
     */
    release?: CreateRecordingEnvelopePayloadRelease | null;
}

/**
 * Check if a given object implements the CreateRecordingEnvelopePayload interface.
 */
export function instanceOfCreateRecordingEnvelopePayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recording" in value;

    return isInstance;
}

export function CreateRecordingEnvelopePayloadFromJSON(json: any): CreateRecordingEnvelopePayload {
    return CreateRecordingEnvelopePayloadFromJSONTyped(json, false);
}

export function CreateRecordingEnvelopePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingEnvelopePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recording': CreateRecordingEnvelopePayloadRecordingFromJSON(json['recording']),
        'artists': !exists(json, 'artists') ? undefined : ((json['artists'] as Array<any>).map(CreateRecordingEnvelopePayloadArtistsInnerFromJSON)),
        'contributions': !exists(json, 'contributions') ? undefined : ((json['contributions'] as Array<any>).map(CreateRecordingEnvelopePayloadContributionsInnerFromJSON)),
        'release': !exists(json, 'release') ? undefined : CreateRecordingEnvelopePayloadReleaseFromJSON(json['release']),
    };
}

export function CreateRecordingEnvelopePayloadToJSON(value?: CreateRecordingEnvelopePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recording': CreateRecordingEnvelopePayloadRecordingToJSON(value.recording),
        'artists': value.artists === undefined ? undefined : ((value.artists as Array<any>).map(CreateRecordingEnvelopePayloadArtistsInnerToJSON)),
        'contributions': value.contributions === undefined ? undefined : ((value.contributions as Array<any>).map(CreateRecordingEnvelopePayloadContributionsInnerToJSON)),
        'release': CreateRecordingEnvelopePayloadReleaseToJSON(value.release),
    };
}

